module.exports = __webpack_public_path__ + "images/offer-dc6164d3302b8c205b6378f6dd7f8736.png";